module.exports = __webpack_public_path__ + "static/media/above_the_trees_logo.6944e258.svg";